// /Users/sagi.antebi/git/fotoscapes/src/utils/crypt-util.ts
import crypto from 'crypto';

/**
 * Computes a checksum by incrementally updating a hash object from a list of items.
 * This is more memory-efficient than creating a single large string from all items first.
 *
 * @param items An array of items to include in the checksum.
 *              - Strings are added directly to the hash.
 *              - Other types (objects, arrays, numbers) are JSON.stringified before being added.
 */
export const computeChecksum = (items: any[]): string => {
  const hash = crypto.createHash('md5');

  for (const item of items) {
    if (typeof item === 'string') {
      // Add strings directly without extra quotes
      hash.update(item);
    } else if (item === null || item === undefined) {
      // Use a constant to represent null/undefined to avoid ambiguity in the hash
      hash.update('__NULL_OR_UNDEFINED__');
    } else {
      // For objects, arrays, numbers, booleans, etc., stringify them.
      hash.update(JSON.stringify(item));
    }
  }

  return hash.digest('hex');
};
